import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _get from "lodash/get";
import _pick from "lodash/pick";
var _excluded = ["children", "impressionProps"],
    _excluded2 = ["ref"];
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ImpressionContext, useImpression } from '@nerdwallet/analytics/react/impression';
import { getApplyLink, getId, getInstitutionId, getOffer, getProductId, getProductType, isNonMonetizing } from '@nerdwallet/marketplace/selectors/common';
import MarketplaceApplyNow from './marketplace-apply-now';

var MarketplaceApplyNowImpression = function MarketplaceApplyNowImpression(_ref) {
  var children = _ref.children,
      impressionProps = _ref.impressionProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var impressionContext = useContext(ImpressionContext);

  var isMonetizing = function isMonetizing(marketplaceEntity, monetizable) {
    if (!monetizable) {
      return isNonMonetizing(marketplaceEntity) ? 'no' : 'yes_assumed';
    }

    return monetizable;
  }; // expected product_impression event payload


  var eventPayload = _pick(impressionProps === null || impressionProps === void 0 ? void 0 : impressionProps.payload, ['element_position', 'driver', 'destination_url', 'marketplace_institution_id', 'marketplace_offer_id', 'marketplace_product_id', 'marketplace_product_type', 'monetizable', 'page_number', 'parent_impression_id', 'section_name', 'section_position']);

  var marketplaceEntity = props === null || props === void 0 ? void 0 : props.marketplaceEntity;

  var sectionName = _get(eventPayload, 'section_name');

  var monetizable = isMonetizing(marketplaceEntity, eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.monetizable);

  var _useImpression = useImpression({
    entityName: impressionProps === null || impressionProps === void 0 ? void 0 : impressionProps.entityName,
    eventType: _get(impressionProps, 'eventType', 'product_impression'),
    payload: _objectSpread({
      destination_url: getApplyLink(marketplaceEntity),
      driver: _get(props, 'productDisplayDriver', 'user_selected'),
      marketplace_institution_id: getInstitutionId(marketplaceEntity),
      marketplace_offer_id: getId(getOffer(marketplaceEntity)),
      marketplace_product_id: getProductId(marketplaceEntity),
      marketplace_product_type: getProductType(marketplaceEntity),
      monetizable: monetizable,
      section_name: sectionName,
      parent_impression_id: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId
    }, eventPayload),
    refireOnEventChange: _get(impressionProps, 'refireOnEventChange', true)
  }),
      ref = _useImpression.ref,
      impression = _objectWithoutProperties(_useImpression, _excluded2);

  var Component = _get(impressionProps, 'component', 'div');

  var updatedProps = _objectSpread({
    impressionId: impression === null || impression === void 0 ? void 0 : impression.impressionId,
    monetizable: monetizable,
    section_name: sectionName
  }, props);

  return /*#__PURE__*/React.createElement(ImpressionContext.Provider, {
    value: impression
  }, /*#__PURE__*/React.createElement(Component, {
    ref: ref
  }, /*#__PURE__*/React.createElement(MarketplaceApplyNow, updatedProps, children)));
};

MarketplaceApplyNowImpression.propTypes = _objectSpread({
  children: PropTypes.node,
  impressionProps: PropTypes.shape({
    component: PropTypes.element,
    entityName: PropTypes.string,
    eventType: PropTypes.string,
    payload: PropTypes.shape({
      element_position: PropTypes.number,
      driver: PropTypes.oneOf(['user_selected', 'recently_viewed', 'meid']),
      destination_url: PropTypes.string,
      marketplace_institution_id: PropTypes.string,
      marketplace_offer_id: PropTypes.string,
      marketplace_product_id: PropTypes.string,
      marketplace_product_type: PropTypes.string,
      monetizable: PropTypes.oneOf(['yes_assumed', 'no', 'no_because_of_limit', 'no_because_of_lead']),
      page_number: PropTypes.number,
      section_name: PropTypes.string,
      section_position: PropTypes.number
    }),
    refireOnEventChange: PropTypes.bool
  })
}, MarketplaceApplyNow.propTypes);
MarketplaceApplyNowImpression.defaultProps = {
  children: null,
  impressionProps: {
    eventType: 'product_impression',
    component: 'div',
    refireOnEventChange: true
  }
};
export default MarketplaceApplyNowImpression;